import React from 'react';
import { MapPin, Shield, Zap, CheckCircle2 } from 'lucide-react';
import { siteConfig } from '../data/mock';

const HeroSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.phone}?text=${encodeURIComponent(siteConfig.whatsappDefault)}`;
  const quoteLink = `https://wa.me/${siteConfig.phone}?text=${encodeURIComponent('Olá! Gostaria de solicitar uma cotação gratuita.')}`;
  const quoteLink2 = "https://chat.goprotege.com/assistente";

  return (
    <section id="inicio" className="relative min-h-screen bg-[#0a0f1e] overflow-hidden">
      {/* Background Image with Zoom Effect */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0f1e]/90 via-[#0a0f1e]/80 to-[#0a0f1e]/85 z-10"></div>
        <img 
          src="https://images.unsplash.com/photo-1634743556192-d19f0c69ff3a?w=1920&q=80" 
          alt="Background" 
          className="absolute inset-0 w-full h-full object-cover scale-110 opacity-30"
          style={{ transform: 'scale(1.15)' }}
        />
        <div className="absolute inset-0 opacity-20 z-[5]" style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, rgba(37, 99, 235, 0.2) 0%, transparent 50%),
                           radial-gradient(circle at 80% 80%, rgba(16, 185, 129, 0.15) 0%, transparent 50%)`
        }}></div>
      </div>

      <div className="container mx-auto px-6 md:px-8 pt-32 pb-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-2">
              <MapPin className="w-4 h-4 text-blue-400" />
              <span className="text-blue-400 text-sm font-medium">Atendimento local em Sorocaba/SP</span>
            </div>

            {/* Main Heading */}
            <div>
              <h1 className="text-4xl sm:text-5xl xl:text-6xl font-black text-white leading-[1.05] tracking-tight mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Rastreamento <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">Veicular</span> em Sorocaba
                <br />
                <span className="text-xl sm:text-3xl xl:text-4xl font-semibold text-slate-300">
                  Monitoramento 24h e Bloqueio Remoto
                </span>
              </h1>
            </div>

            <p className="text-base sm:text-lg text-gray-400 leading-relaxed">
              Proteja seu veículo ou gerencie sua frota empresarial com tecnologia de ponta em Sorocaba e região. 
              Rastreador com bloqueio remoto, app completo e suporte técnico especializado.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={quoteLink2}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white px-7 py-3.5 rounded-xl font-bold text-[15px] transition-all shadow-lg hover:shadow-blue-600/50 hover:scale-105 text-center"
              >
                Solicitar Cotação Gratuita
              </a>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-7 py-3.5 rounded-xl font-bold text-[15px] transition-all shadow-lg hover:shadow-green-500/50 hover:scale-105 flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                Falar no WhatsApp
              </a>
            </div>

            {/* Feature Badges */}
            <div className="flex flex-wrap gap-5 sm:gap-6">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span className="text-gray-300 text-[15px] font-medium">Suporte 24h</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span className="text-gray-300 text-[15px] font-medium">Instalação Rápida</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span className="text-gray-300 text-[15px] font-medium">Rastreamento Ativo</span>
              </div>
            </div>
          </div>

          {/* Right Content - Tracking Card */}
          <div className="lg:pl-8">
            <div className="bg-gradient-to-br from-blue-950/50 to-slate-900/50 backdrop-blur-sm border border-blue-500/20 rounded-2xl p-6 shadow-2xl">
              {/* Status Badge */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg">Rastreamento Ativo</h3>
                    <div className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                      <span className="text-green-400 text-sm font-medium">Online agora • Sorocaba/SP</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="relative h-64 bg-slate-800/50 rounded-xl overflow-hidden mb-6">
                <img
                  src="https://customer-assets.emergentagent.com/job_tracker-clone/artifacts/l3nnh50b_Gemini_Generated_Image_l2d1w9l2d1w9l2d1.png"
                  alt="Sorocaba Avenida Dom Aguirre"
                  className="w-full h-full object-cover opacity-70"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                    <MapPin className="w-8 h-8 text-white" />
                  </div>
                </div>
                <div className="absolute bottom-4 left-4 bg-slate-900/90 backdrop-blur-sm px-4 py-2 rounded-lg">
                  <p className="text-white text-sm font-medium">Sorocaba • Avenida Dom Aguirre</p>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="text-center">
                  <div className="text-2xl font-bold text-white mb-1">24h</div>
                  <div className="text-xs text-gray-400">Monitoramento</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white mb-1">100%</div>
                  <div className="text-xs text-gray-400">Cobertura BR</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-white mb-1">5★</div>
                  <div className="text-xs text-gray-400">Avaliação</div>
                </div>
              </div>

              {/* Alert */}
              <div className="bg-green-500/10 border border-green-500/30 rounded-lg px-4 py-3 flex items-center justify-between">
                <span className="text-green-400 text-sm font-medium">Alerta: Cerca virtual ativa</span>
                <button className="text-blue-400 text-sm font-medium hover:text-blue-300 transition-colors">
                  Saiba mais
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
